import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {BUSINESS_NAME, OG_PATH} from "@/content";

const slug = 'slab-formwork-and-raft-slabs-sydney';
const serviceId = 4
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {

    const metaTags : MetaTagsProps =  {
        title: `Slab Formwork & Raft Slabs Sydney | ${BUSINESS_NAME}`,
        description: "Durable slab solutions for homes, units, and large developments.",
        keywords: "slab formwork Sydney, raft slabs Sydney, concrete slab solutions, residential slab formwork, commercial slab formwork, industrial slab formwork, reinforced concrete slabs, custom slab designs, durable concrete slabs, Sydney construction services",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Slab Formwork & Raft Slabs Sydney',
    description: 'Durable slab solutions for homes, units, and large developments.',
    points: [

    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
